import { motion } from "framer-motion";
import { Shield, Globe, Headphones, Users } from "lucide-react";
import { useT } from "@/i18n";

const statIcons = [Shield, Users, Globe, Headphones];

export default function TrustSection() {
  const t = useT();
  const tr = t.trust;
  const stats = [
    { value: "25+", label: tr.stats.years },
    { value: "100k+", label: tr.stats.customers },
    { value: "3", label: tr.stats.languages },
    { value: "24h", label: tr.stats.response },
  ];

  return (
    <section data-testid="trust-section" className="py-24 sm:py-32 relative">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-px bg-gradient-to-r from-transparent via-orange-500/30 to-transparent" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
            <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-orange-400 mb-4">{tr.overline}</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-white mb-6">{tr.title}</h2>
            <p className="text-base sm:text-lg text-slate-400 leading-relaxed mb-8">{tr.desc}</p>
            <div className="flex flex-wrap gap-3">
              {tr.langs.map((lang) => (
                <span key={lang} className="inline-flex items-center px-4 py-2 rounded-full text-sm bg-white/5 border border-white/10 text-slate-300">{lang}</span>
              ))}
            </div>
          </motion.div>
          <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.1 }} className="grid grid-cols-2 gap-4">
            {stats.map((stat, index) => {
              const Icon = statIcons[index];
              return (
                <motion.div key={index} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: 0.15 * index }}
                  data-testid={`trust-stat-${index}`} className="glass-card rounded-3xl p-6 sm:p-8 text-center">
                  <div className="w-10 h-10 rounded-xl bg-orange-500/10 border border-orange-500/20 flex items-center justify-center mx-auto mb-4">
                    <Icon className="w-5 h-5 text-orange-400" strokeWidth={1.5} />
                  </div>
                  <p className="text-3xl sm:text-4xl font-semibold tracking-tighter text-white mb-1">{stat.value}</p>
                  <p className="text-sm text-slate-500">{stat.label}</p>
                </motion.div>
              );
            })}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
